const mapping: Record<string, string> = {
  id: 'l=>l.Id',
  name: 'l=>l.Name',
  defaultTitle: 'l=>l.DefaultTitle',
  defaultDescription: 'l=>l.DefaultDescription',
}

export const mapSortCategoriesParam = (key: string) => mapping[key]
